import api from './axiosInstance'

export const resource = {

}

export default {
    async list(source) {
        return await api.get(source)
            .then(res => res.data._items)
            .catch(error => {
                console.log('Error: ', error)
                return []
            });
    },
    async getById(source, id) {
        return await api.get(`${source}/${id}`)
            .then(res => res.data)
            .catch(error => {
                console.log('Error: ', error)
                return null;
            });
    },
    doPublish(source,id,isPublish) {
        return api.patch(`${source}/${id}`, {isPublished: isPublish});
    },
    delete(source,id) {
        return api.delete(`${source}/${id}`);
    },
    getSubscriberCount(){
        return api.get('/user-count');
    },
    checkProjectName(projectName){
        console.log("Project name ",projectName);
        return api.get('/checkProjectName?project_name='+projectName);
    },
    generateSocialMediaData(project_id,data){
        return api.post(`/socialMediaData/?project_id=${project_id}`,data);
    }
}